import { Component } from '@angular/core';
import { QuestionService } from './inputfileds/form_services/question/question.service';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout/layout.component';
import { AuthenticationService } from './components/Authentication/services/authentication.service';
import { ThemeService } from './Services/themes.service';

@Component({
    selector: 'app-root',
    imports: [ CommonModule, LayoutComponent],
    providers: [QuestionService],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'visaka_erp';
  user: any;
  loading = false;
  constructor(
    private authenticationService: AuthenticationService,
    private themeService: ThemeService
  ) {
    // if (this.authenticationService?.user) {
    //   this.authenticationService?.user.subscribe(x =>  this.user = x);
    //   this.loading = true;
    // }else {
    //   this.loading = true;
    // }
  }

  ngOnInit(): void {
    this.themeService.loadThemeOnStart();
  }

  ngAfterContentChecked() {
    // if (this.authenticationService?.user) {
    //   this.authenticationService?.user.subscribe(x => this.user = x);
    // }
  }
}
